import { render, staticRenderFns } from "./ProfileChangeUserAge.vue?vue&type=template&id=230af498&scoped=true"
import script from "./ProfileChangeUserAge.vue?vue&type=script&lang=js"
export * from "./ProfileChangeUserAge.vue?vue&type=script&lang=js"
import style0 from "./ProfileChangeUserAge.vue?vue&type=style&index=0&id=230af498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230af498",
  null
  
)

export default component.exports